<app-dialog-base [Title]='"Completed work" |translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="btn_tabs">
    <button type="button" (click)="openTab('main', $event)" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
    <button type="button" (click)="openTab('tasks', $event)" [class.active]="openedTabName == 'tasks'">{{"Service tasks"|translate}}</button>
  </div>

  <div class="horseparator"></div>

  <div id="main" [style.display]="isSelected('main') ? '' : 'none'" class="tablewrap">
    <div class="inputgroup">
      <label>{{'Object'|translate }}</label>
      <input type="text" [ngModel]="model.ObjectName" disabled />
    </div>
    <div class="inputgroup">
      <label>{{'Name'|translate }}</label>
      <input type="text" [(ngModel)]="model.Name" />
    </div>
    <div class="inputgroup inputgroupwithtextarea">
      <label>{{'Description'|translate }}</label>
      <textarea rows="5" [(ngModel)]="model.Comment"></textarea>
    </div>
    <div class="inputgroup">
      <span>
        <label>{{'Date'|translate }}</label>
      </span>
      <calendar [name]="'Time'" [(date)]="model.Time"></calendar>
    </div>
    <div class="inputgroup">
      <label>{{'Address'|translate }}</label>
      <input type="text" [(ngModel)]="model.Address" />
    </div>
    <div class="inputgroup">
      <span>
        <label>{{'Cost'|translate }}</label>
      </span>
      <input type="number" [(ngModel)]="model.Cost" />
    </div>
    <div class="inputgroup">
      <span>
        <label>{{'Duration'|translate }}</label>
      </span>
      <label>
        <input type="number" [ngModel]="model.Duration | localizeHours" (ngModelChange)="convertDuration($event)" />
        <span>{{'h'|translate}}</span>
      </label>
    </div>
    <div class="inputgroup">
      <span>
        <label>{{'Odometer'|translate }}</label>
      </span>
      <label>
        <input type="number" [ngModel]="model.Odometr | localizeKMeters" (ngModelChange)="convertOdometr($event)" />
        <span>{{'km'|localizeUnits}}</span>
      </label>
    </div>
    <div class="inputgroup">
      <span>
        <label>{{'Engine time'|translate }}</label>
      </span>
      <label>
        <input type="number" [ngModel]="model.WorkTime | localizeHours" (ngModelChange)="convertEngineTime($event)" />
        <span>{{'h'|translate}}</span>
      </label>
    </div>
  </div>
  <div id="tasks" [style.display]="isSelected('tasks') ? '' : 'none'" class="tablewrap">
    <div class="table">
      <table fixedcols="[0]">
        <tr>
          <th>
            <switch-all-checkbox [items]="objects" />
          </th>
          <th>{{'Name'|translate }}</th>
        </tr>
        <tr *ngFor="let object of objects">
          <td><input type="checkbox" [(ngModel)]="object.IsChecked" (change)="onToggle(object)" /></td>
          <td>{{object.Name}}</td>
        </tr>
      </table>
    </div>
  </div>

</app-dialog-base>
